import BookCover from "./components/BookCover";
function App() {
  return (
      <BookCover />
  );
}

export default App;
